import script from "./Login.vue?vue&type=script&setup=true&lang=ts"
export * from "./Login.vue?vue&type=script&setup=true&lang=ts"

import "./Login.vue?vue&type=style&index=0&id=6a007180&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6a007180"]])

export default __exports__